module.exports = __webpack_public_path__ + "Flag-454.24fc91e9afb7cbc9d17eb1f0611a6ded.svg";